import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { SERVER_SPEC_MENTION, RENDER_SPEC_MENTION, HIGHLIGHTED_TEXT_REGEX, COMMON_REGEX } from './regexp.mjs';

function parseServerSpecMention(text) {
  var mentions = [];
  var match;
  do {
    if (match) {
      var _match = match,
        _match2 = _slicedToArray(_match, 3),
        origin = _match2[0],
        type = _match2[1],
        id = _match2[2];
      var newMentionObject = {
        origin: origin,
        type: type,
        id: id
      };
      mentions.push(newMentionObject);
    }
    match = SERVER_SPEC_MENTION.exec(text);
  } while (match !== null);
  return mentions;
}
function parseRenderSpecMention(text) {
  var mentions = [];
  var match;
  do {
    if (match) {
      var _match3 = match,
        _match4 = _slicedToArray(_match3, 3),
        origin = _match4[0],
        type = _match4[1],
        id = _match4[2];
      var newMentionObject = {
        origin: origin,
        type: type,
        id: id
      };
      mentions.push(newMentionObject);
    }
    match = RENDER_SPEC_MENTION.exec(text);
  } while (match !== null);
  return mentions;
}
function parseServerSpecHighlight(text) {
  var highlightedTexts = [];
  var match;
  do {
    if (match) {
      var _match5 = match,
        _match6 = _slicedToArray(_match5, 3),
        origin = _match6[0],
        type = _match6[1],
        highlightedText = _match6[2];
      var newHighlightedTextObject = {
        origin: origin,
        type: type,
        text: highlightedText,
        length: origin.length
      };
      highlightedTexts.push(newHighlightedTextObject);
    }
    match = HIGHLIGHTED_TEXT_REGEX.exec(text);
  } while (match !== null);
  return highlightedTexts;
}
function parseCommonFormat(text) {
  var result = [];
  var match;
  do {
    if (match) {
      var _match7 = match,
        _match8 = _slicedToArray(_match7, 4),
        origin = _match8[0],
        type = _match8[1],
        value = _match8[2],
        fallback = _match8[3];
      result.push({
        origin: origin,
        type: type,
        value: value,
        fallback: fallback
      });
    }
    match = COMMON_REGEX.exec(text);
  } while (match !== null);
  return result;
}

export { parseCommonFormat, parseRenderSpecMention, parseServerSpecHighlight, parseServerSpecMention };
